import { HStack, Box } from '@cad-arc';
import { observer } from 'mobx-react';
import { NotificationCounter } from '../../common/components/notification-counter';
import { useActiveConversationsUnreadInfo } from '../../common/hooks/use-active-conversations-unread-info';
import { WorkspacePanelButton } from '../../panels/workspace-panel-button';

export const MessagingButton = observer(
    (): React.ReactElement => {
        const { unreadCount, hasUrgentUnread } = useActiveConversationsUnreadInfo();

        return (
            <HStack position="relative">
                <WorkspacePanelButton
                    tooltipText="Messaging"
                    workspacePanelType="MESSAGING"
                    aria-label="open messaging"
                    icon="Messaging"
                />
                <Box
                    position="absolute"
                    right="0"
                    top="0"
                    transform="translate(25%, 3%)"
                    data-testid="unread-counter"
                >
                    <NotificationCounter isUrgent={hasUrgentUnread}>
                        {unreadCount}
                    </NotificationCounter>
                </Box>
            </HStack>
        );
    }
);
